import React, { useContext } from 'react'
import SurveysSummaryDraft from './SurveySummaryDraft'
import SurveySummaryOpen from './SurveySummaryOpen'

import './SurveySummary.less'
import { ManageSurveyContext } from '../ManageSurveyContext'

const SurveySummary = () => {
  const { survey } = useContext(ManageSurveyContext)

  if (!!survey.published_at || !!survey.completed_at) {
    return <SurveySummaryOpen />
  } else {
    return <SurveysSummaryDraft />
  }
}

export default SurveySummary
